import BigNumber from 'bignumber.js'
import { ONE, ZERO } from 'constants/number'
import { makeAutoObservable } from 'mobx'

class BetaLaunchStore {
  maxTVL: BigNumber
  maxInviteWhitelist: number
  currentTVL: BigNumber

  constructor() {
    this.maxTVL = ONE
    this.maxInviteWhitelist = 0
    this.currentTVL = ZERO
    makeAutoObservable(this)
  }

  setMaxTVL = (value: BigNumber) => {
    this.maxTVL = value
  }

  setMaxInviteWhitelist = (value: number) => {
    this.maxInviteWhitelist = value
  }

  setCurrentTVL = (value: BigNumber) => {
    this.currentTVL = value
  }
}

export const betaLaunchStore = new BetaLaunchStore()
